import { Icon } from '@ridi/rsg';
import { createElement } from 'react';

var CheckBox = function (props) {
    var checked = props.checked, onChange = props.onChange, disabled = props.disabled, children = props.children, className = props.className;
    return (createElement("label", { className: "RUICheckBox " + className },
        createElement("input", { type: "checkbox", className: "RUICheckBox_Input", checked: checked, disabled: disabled, onChange: onChange }),
        createElement("span", { className: "RUICheckBox_Label" },
            createElement(Icon, { name: "check_1", className: "RUICheckBox_SVGIcon" }),
            children)));
};

export { CheckBox };
//# sourceMappingURL=CheckBox.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/CheckBox.js